/*
 * Copyright (c) 2021 WIT Software. All rights reserved.
 *
 * WIT Software Confidential and Proprietary information. It is strictly forbidden for 3rd parties to modify, decompile,
 * disassemble, defeat, disable or circumvent any protection mechanism; to sell, license, lease, rent, redistribute or
 * make accessible to any third party, whether for profit or without charge.
 *
 */

import { call } from 'redux-saga/effects';

import { combineReducers } from 'redux';
import * as NavigationWatcher from './navigationWatcher';
import * as NavigationPathWatcher from './navigationPathWatcher';
import * as ActionsWatcher from './actionsWatcher';
import * as TechnicalData from './technicalData';

export default combineReducers({
  actionsWatcher: ActionsWatcher.default,
  navigationPathWatcher: NavigationPathWatcher.default,
});

export const sagas = [
  call(NavigationWatcher.saga),
  call(ActionsWatcher.saga),
  call(TechnicalData.saga),
  call(NavigationPathWatcher.saga),
];
